import API from './axios.js';


export const getAllGlobalSettingsData = () => API.get('global-settings');
export const updateAllGlobalSettingsData = () => API.get('global-settings');


export const getRights = () => API.get('global-settings/rights');
export const updateRights = (payload) => API.patch('global-settings/rights',payload);


export const updateExpenseSettings = (payload) => API.patch('global-settings/expense-settings',payload);
export const updateInvoiceSettings = (payload) => API.patch('global-settings/invoice-settings',payload);
export const updateTaskSettings = (payload) => API.patch('global-settings/task-settings',payload);
export const updateLabelSettings = (payload) => API.patch('global-settings/label-settings',payload);

// VISIBILITY
export const getVisibility = () => API.get('global-settings/visibility');
export const updateVisibility = (payload) => API.patch('global-settings/visibility', payload);
// export const getExpenseByID = (expID) => API.get(`expense/${expID}`);
// export const saveExpense = (expenseData) => API.post('expense', expenseData);
// export const updateExpense = (expenseData,id) => API.patch(`expense/${id}`, expenseData);
// export const deleteExpense = (id) => API.delete(`expense/${id}`);

export const createAccByEmailConfig = (payload) => API.patch('global-settings/email-config',payload);
export const delAccByEmailConfig = (payload) => API.patch('global-settings/email-config',payload);

export const getUserRights = (userId) => API.get(`auth/user-rights/${userId}`);
export const getVisibilityRights = () => API.get('global-settings/rights');

export const checkEmailConfigPassword = (payload) => API.post('global-settings/email-config/check-password', payload);


export const getUserRightsByToken = () => API.get('auth/user-rights-by-token');

export const updateCaseSettings = (payload) => API.patch('global-settings/case-settings',payload);

export const addOrUpdateColumnData = (payload) => API.post('custom-attribute',payload);

export const updateAlertSettings = (payload) => API.patch('global-settings/alerts/whatsapp',payload);